import ApiClient from '../ApiClient';

class CrmCardsAPI extends ApiClient {
  constructor() {
    super('crm/cards', { accountScoped: true });
  }

  // POST /api/v1/accounts/:id/crm/cards/:cardId/move
  move(cardId, { stageId, position = 0 }) {
    return axios.post(`${this.url}/${cardId}/move`, {
      stage_id: stageId,
      position,
    });
  }

  listByPipeline(pipelineId, { includeArchived = false } = {}) {
    return axios.get(this.url, {
      params: {
        pipeline_id: pipelineId,
        include_archived: includeArchived,
      },
    });
  }

  listByStage(stageId) {
    return axios.get(this.url, { params: { stage_id: stageId } });
  }
}

export default new CrmCardsAPI();
